import { render, staticRenderFns } from "./investmentManagement.vue?vue&type=template&id=0594a5fd&scoped=true&"
import script from "./investmentManagement.vue?vue&type=script&lang=js&"
export * from "./investmentManagement.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=0594a5fd&prod&lang=scss&scoped=true&"
import style1 from "./investmentManagement.vue?vue&type=style&index=1&id=0594a5fd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0594a5fd",
  null
  
)

export default component.exports